import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const LocationDetails = ({ location }) => {
  const handleGetDirections = () => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${location?.lat},${location?.lng}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-md">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className="relative h-64 md:h-80 lg:h-full min-h-[300px]">
          <Image
            src={location?.image}
            alt={location?.imageAlt}
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg">
            <Icon name="MapPin" size={14} />
            <span className="caption font-medium">{location?.type}</span>
          </div>
          {location?.rating && (
            <div className="absolute top-4 right-4 bg-card/95 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg">
              <Icon name="Star" size={14} className="text-accent fill-accent" />
              <span className="caption font-medium text-foreground">{location?.rating}</span>
            </div>
          )}
        </div>

        <div className="p-6 md:p-8">
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground mb-2">
            {location?.name}
          </h2>
          
          <div className="space-y-4 mb-6">
            <div className="flex items-start gap-3">
              <Icon name="MapPin" size={20} className="text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Address</p>
                <p className="text-sm text-muted-foreground">{location?.address}</p>
              </div>
            </div>

            {location?.phone && (
              <div className="flex items-start gap-3">
                <Icon name="Phone" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Contact</p>
                  <a href={`tel:${location?.phone}`} className="text-sm text-primary hover:underline">
                    {location?.phone}
                  </a>
                </div>
              </div>
            )}

            {location?.hours && (
              <div className="flex items-start gap-3">
                <Icon name="Clock" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Hours</p>
                  <p className="text-sm text-muted-foreground">{location?.hours}</p>
                </div>
              </div>
            )}
          </div>

          {location?.features && location?.features?.length > 0 && (
            <div className="mb-6">
              <p className="text-sm font-medium text-foreground mb-3">Amenities</p>
              <div className="flex flex-wrap gap-2">
                {location?.features?.map((feature, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-muted text-foreground rounded-md text-sm"
                  >
                    <Icon name="Check" size={14} className="text-success" />
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          )}

          <Button
            variant="default"
            fullWidth
            iconName="Navigation"
            iconPosition="left"
            onClick={handleGetDirections}
          >
            Get Directions
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;